import React from "react";

export default function Success() {
  return (
    <div className="ds-card _addTopMargin">
      <section className="cardSection _withColumns">
        <section className="cardSection --micro _withColumns _simple">
          <i className="materialIcon -success --small">check_circle</i>
          <p className="copy emphasize -success">Thank you for your feedback!</p>
        </section>
      </section>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/feedbacks/components/Success.js